import React from 'react';
import { useField } from 'formik';
import _handleStatusFormik from '../../../Helpers/StatusFormik';
import CheckInput from '../common/src/checkInput/CheckInput';

const CheckInputFormik = (props) => {
    const [field, meta, helpers] = useField(props);
    const { error, touched } = meta;

    return <>
        <CheckInput error={error && touched} {...field} {...props} state={_handleStatusFormik(meta)} />
        {error && touched && <p className="--red-500 gender --validation --fivexs">{error}</p>}
    </>;
};

export default CheckInputFormik;
